<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_APPROVALS')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_APPROVALS')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">

        <ng-container *ngIf="accessService.authorized(project, 'PROJECT_SHOW_APPROVAL_PROJECT')">
            <h4>Freigaben als Projekt</h4>

            <table class="table table-striped table-sm" *ngIf="this.formService.getFormArray(this.form, 'approvalsProject').controls.length > 0">
                <thead>
                <tr>
                    <th style="width: 200px">Freigabe von</th>
                    <th style="width: 180px">Rolle</th>
                    <!--<th style="width: 130px">Erstellt am</th>-->
                    <th style="width: 110px">Genehmigt</th>
                    <th style="width: 130px">Eingetragen am</th>
                    <th style="width: 200px">Eingetragen von</th>
                    <th>Anmerkung</th>
                </tr>
                </thead>
                <tbody formArrayName="approvalsProject">
                <tr [formGroupName]="i"
                    *ngFor="let entry of formService.getFormArray(form, 'approvalsProject').controls; let i = index">
                    <td>
                        {{ entry.value.approver }}
                    </td>
                    <td>{{ entry.value.role | teamRole }}</td>
                    <!--<td>
                        {{ entry.value.created | date: "dd.MM.yyyy" }}
                    </td>-->
                    <td>
                        <ng-container *ngIf="viewMode !== ViewMode.VIEW && entry.value.entered === null">
                            <div class="form-check" style="display: inline-block">
                                <input class="form-check-input" type="radio" value="1" formControlName="approved" [disableControl]="!canEditApproval(entry)">
                                <label class="form-check-label">
                                    <span style="color: green">Ja</span>
                                </label>
                            </div>
                            <div class="form-check ms-2" style="display: inline-block">
                                <input class="form-check-input" type="radio" value="0" formControlName="approved" [disableControl]="!canEditApproval(entry)">
                                <label class="form-check-label">
                                    <span style="color: red">Nein</span>
                                </label>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW || entry.value.entered !== null">
                            <span [class.text-success]="entry.value.approved === '1'"
                                  [class.text-danger]="entry.value.approved === '0'">
                                {{ entry.value.approved !== null ? entry.value.approved === '1' ? 'Ja' : 'Nein': ''}}
                            </span>
                            <span class="text-muted" *ngIf="entry.value.approved === null">Offen</span>
                        </ng-container>
                    </td>
                    <td>
                        {{ entry.value.updated ? (entry.value.updated | date: "dd.MM.yyyy") : "" }}
                    </td>
                    <td>
                        {{ entry.value.entered ? entry.value.entered : "" }}
                    </td>
                    <td>
                        <textarea class="form-control" placeholder="Anmerkung" formControlName="note"
                                  *ngIf="viewMode !== ViewMode.VIEW && entry.value.entered === null"
                                  [disableControl]="!canEditApproval(entry)">
                        </textarea>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW || entry.value.entered !== null">
                            {{ entry.value.note }}
                        </ng-container>
                    </td>
                </tr>
                </tbody>
            </table>

            <button type="button" class="btn btn-secondary btn-sm mb-2" *ngIf="oldApprovals.project.entries.length > 0" (click)="toggleOldApprovals('project')">
                Bisherige Freigaben {{ oldApprovals.project.show ? 'verbergen' : 'anzeigen'}}
            </button>

            <table class="table table-striped table-sm" *ngIf="oldApprovals.project.show">
                <thead>
                <tr>
                    <th style="width: 200px">Freigabe von</th>
                    <th style="width: 180px">Rolle</th>
                    <!--<th style="width: 130px">Erstellt am</th>-->
                    <th style="width: 110px">Genehmigt</th>
                    <th style="width: 130px">Eingetragen am</th>
                    <th style="width: 200px">Eingetragen von</th>
                    <th>Anmerkung</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let entry of oldApprovals.project.entries">
                    <td>
                        {{ entry.approver }}
                    </td>
                    <td>{{ entry.role | teamRole }}</td>
                    <!--<td>
                        {{ entry.created | date: "dd.MM.yyyy" }}
                    </td>-->
                    <td>
                        <ng-container *ngIf="entry.entered !== null">
                            <span [class.text-success]="entry.approved === '1'"
                                  [class.text-danger]="entry.approved === '0'">
                                {{ entry.approved !== null ? entry.approved === '1' ? 'Ja' : 'Nein': ''}}
                            </span>
                            <span class="text-muted" *ngIf="entry.approved === null">Offen</span>
                        </ng-container>
                    </td>
                    <td>
                        {{ entry.updated ? (entry.updated | date: "dd.MM.yyyy") : "" }}
                    </td>
                    <td>
                        {{ entry.entered ? entry.entered : "" }}
                    </td>
                    <td>
                        {{ entry.note }}
                    </td>
                </tr>
                </tbody>
            </table>
        </ng-container>

        <ng-container *ngIf="accessService.authorized(project, 'PROJECT_SHOW_APPROVAL_COMPLETION')">
            <h4>Freigaben für Abschluss</h4>

            <table class="table table-striped table-sm" *ngIf="this.formService.getFormArray(this.form, 'approvalsCompletion').controls.length > 0">
                <thead>
                <tr>
                    <th style="width: 200px">Freigabe von</th>
                    <th style="width: 180px">Rolle</th>
                    <!--<th style="width: 130px">Erstellt am</th>-->
                    <th style="width: 110px">Genehmigt</th>
                    <th style="width: 130px">Eingetragen am</th>
                    <th style="width: 200px">Eingetragen von</th>
                    <th>Anmerkung</th>
                </tr>
                </thead>
                <tbody formArrayName="approvalsCompletion">
                <tr [formGroupName]="i"
                    *ngFor="let entry of formService.getFormArray(form, 'approvalsCompletion').controls; let i = index">
                    <td>
                        {{ entry.value.approver }}
                    </td>
                    <td>{{ entry.value.role | teamRole }}</td>
                    <!--<td>
                        {{ entry.value.created | date: "dd.MM.yyyy" }}
                    </td>-->
                    <td>
                        <ng-container *ngIf="viewMode !== ViewMode.VIEW && entry.value.entered === null">
                            <div class="form-check" style="display: inline-block">
                                <input class="form-check-input" type="radio" value="1" formControlName="approved" [disableControl]="!canEditApproval(entry)">
                                <label class="form-check-label">
                                    <span style="color: green">Ja</span>
                                </label>
                            </div>
                            <div class="form-check ms-2" style="display: inline-block">
                                <input class="form-check-input" type="radio" value="0" formControlName="approved" [disableControl]="!canEditApproval(entry)">
                                <label class="form-check-label">
                                    <span style="color: red">Nein</span>
                                </label>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW || entry.value.entered !== null">
                            <span [class.text-success]="entry.value.approved === '1'"
                                  [class.text-danger]="entry.value.approved === '0'">
                                {{ entry.value.approved !== null ? entry.value.approved === '1' ? 'Ja' : 'Nein': ''}}
                            </span>
                            <span class="text-muted" *ngIf="entry.value.approved === null">Offen</span>
                        </ng-container>
                    </td>
                    <td>
                        {{ entry.value.updated ? (entry.value.updated | date: "dd.MM.yyyy") : "" }}
                    </td>
                    <td>
                        {{ entry.value.entered ? entry.value.entered : "" }}
                    </td>
                    <td>
                        <textarea class="form-control" placeholder="Anmerkung" formControlName="note"
                                  *ngIf="viewMode !== ViewMode.VIEW && entry.value.entered === null"
                                  [disableControl]="!canEditApproval(entry)">
                        </textarea>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW || entry.value.entered !== null">
                            {{ entry.value.note }}
                        </ng-container>
                    </td>
                </tr>
                </tbody>
            </table>

            <button type="button" class="btn btn-secondary btn-sm mb-2" *ngIf="oldApprovals.completion.entries.length > 0" (click)="toggleOldApprovals('completion')">
                Bisherige Freigaben {{ oldApprovals.completion.show ? 'verbergen' : 'anzeigen'}}
            </button>

            <table class="table table-striped table-sm mb-0" *ngIf="oldApprovals.completion.show">
                <thead>
                <tr>
                    <th style="width: 200px">Freigabe von</th>
                    <th style="width: 180px">Rolle</th>
                    <!--<th style="width: 130px">Erstellt am</th>-->
                    <th style="width: 110px">Genehmigt</th>
                    <th style="width: 130px">Eingetragen am</th>
                    <th style="width: 200px">Eingetragen von</th>
                    <th>Anmerkung</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let entry of oldApprovals.completion.entries">
                    <td>
                        {{ entry.approver }}
                    </td>
                    <td>{{ entry.role | teamRole }}</td>
                    <!--<td>
                        {{ entry.created | date: "dd.MM.yyyy" }}
                    </td>-->
                    <td>
                        <ng-container *ngIf="entry.entered !== null">
                            <span [class.text-success]="entry.approved === '1'"
                                  [class.text-danger]="entry.approved === '0'">
                                {{ entry.approved !== null ? entry.approved === '1' ? 'Ja' : 'Nein': ''}}
                            </span>
                            <span class="text-muted" *ngIf="entry.approved === null">Offen</span>
                        </ng-container>
                    </td>
                    <td>
                        {{ entry.updated ? (entry.updated | date: "dd.MM.yyyy") : "" }}
                    </td>
                    <td>
                        {{ entry.entered ? entry.entered : "" }}
                    </td>
                    <td>
                        {{ entry.note }}
                    </td>
                </tr>
                </tbody>
            </table>
        </ng-container>

    </form>
</div>
